export default {
  // START:: SET APP LOCALE
  setAppLocale(state, payload) {
    state.modo_dashboard_language = payload;
  },
  // END:: SET APP LOCALE
};
